module.exports = __webpack_public_path__ + "static/Wereboar-dab710526ff50e68a76cbac8ca5d82b5.jpg";